let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4pw2D")).then(() => parcelRequire('8HTcg'));